function deepLevelClass(list) {
  $(list).each(function() {
    $(this).find("ul").each(function() {
      var parentCount = $(this).parentsUntil(".menu", "ul").length + 1;
      $(this).addClass("menu-deep-" + parentCount);
    });
  });
}

module.exports = {
  deepLevelClass
}



// WEBPACK FOOTER //
// ../assets/js/nav-level-class.js